import {
  SET_FEED_CUT_OFF_HISTORY,
  SET_FEED_MANUAL_PRICE_HISTORY,
} from 'redux/constants/FeedPrice';

const initState = {
  feedManualPriceHistory: {
    rows: [],
    count: 0,
  },
  feedCutOffHistory: {
    rows: [],
    count: 0,
  },
};

const feedPrice = (state = initState, action) => {
  switch (action.type) {
    case SET_FEED_MANUAL_PRICE_HISTORY:
      return {
        ...state,
        feedManualPriceHistory: action.payload,
      };
    case SET_FEED_CUT_OFF_HISTORY:
      return {
        ...state,
        feedCutOffHistory: action.payload,
      };
    default:
      return state;
  }
};

export default feedPrice;
